/**
 * AlphaX Support Intake Card Wizard
 * Interactive Frontend Controller & State Machine
 */

// 1. Configured Google Apps Script Endpoint URL
const APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyZ9g9_MZ0hZvdwgMFJRpibG0mE0M0JOaysfhPJ7J-8VWnVWeL6LKlURozg0c4bDMQe/exec'; // Paste your deployed Google Apps Script Web App URL here

(function () {
  'use strict';

  // Comprehensive Bilingual Localization Dictionary
  const I18N = {
    es: {
      brandBadge: "AlphaX Soporte & Asistencia",
      mainTitle: "Centro de Asistencia y Soporte AlphaX",
      mainDesc: "Completa los siguientes pasos para dirigir tu consulta al técnico o especialista adecuado.",
      langLabel: "Idioma:",
      
      // Steps headers
      step1Title: "Paso 1: Información de Contacto",
      step1Desc: "Indícanos tus datos para ponernos en contacto contigo y enviarte actualizaciones de tu caso.",
      nameLabel: "Nombre Completo",
      namePlaceholder: "Ej. Carlos Santana",
      emailLabel: "Correo Electrónico",
      emailPlaceholder: "carlos@ejemplo.com",
      phoneLabel: "Teléfono / WhatsApp",
      phonePlaceholder: "Ej. 787-555-0123",
      btnNext: "Continuar",
      btnBack: "Atrás",
      
      step2Title: "¿En qué podemos ayudarte hoy?",
      step2Desc: "Selecciona el área principal de tu consulta:",
      cardSalesTitle: "Ventas y Orientación",
      cardSalesDesc: "Precios, compatibilidad de productos, distribuidores autorizados o compras directas.",
      cardSupportTitle: "Soporte Técnico",
      cardSupportDesc: "Asistencia para instalación de ECUs, accesorios, resolución de fallas o calibración.",

      // Sales branch
      stepSalesTitle: "Orientación y Disponibilidad de Compra",
      stepSalesDesc: "Elige la opción que mejor describa tu necesidad de compra:",
      cardOrientationTitle: "Orientación sobre Productos",
      cardOrientationDesc: "Dudas sobre qué ECU o accesorios requieres para tu proyecto o vehículo.",
      cardDealersTitle: "Disponibilidad y Dónde Comprar",
      cardDealersDesc: "Encuentra tiendas y distribuidores autorizados locales o compra en la tienda online.",
      dealersLinkTitle: "Ver Lista de Distribuidores Autorizados",
      dealersLinkDesc: "Localiza talleres y distribuidores en Puerto Rico, USA e internacional.",
      storeLinkTitle: "Visitar Tienda Oficial AlphaX",
      storeLinkDesc: "Compra directa de ECUs, arneses y accesorios originales.",
      salesNotesLabel: "Cuéntanos sobre tu proyecto o duda:",
      salesNotesPlaceholder: "Indica vehículo, motor y objetivos para recomendarte la mejor opción...",
      btnSubmitSales: "Enviar Consulta de Ventas",

      // Support branch - 4 choices with cliparts
      stepSupportTitle: "Selecciona tu Producto o Servicio",
      stepSupportDesc: "Escoge la categoría correspondiente a tu consulta técnica:",
      cardPnpTitle: "ECU Plug and Play",
      cardPnpDesc: "ECUs de reemplazo directo con conector de fábrica para modelos específicos.",
      cardWireInTitle: "ECU Wire-in / Universal",
      cardWireInDesc: "ECUs programables universales para instalaciones con arnés personalizado o swap.",
      cardAccessoriesTitle: "Accesorios AlphaX",
      cardAccessoriesDesc: "Sensores, solenoides de boost, cableados auxiliares y módulos de expansión.",
      cardTuningTitle: "Soporte de Calibración / Tuning",
      cardTuningDesc: "Mapas base iniciales, sesiones de ajuste remoto y referidos a calibradores certificados.",

      // Issue Details Card (for PnP, Wire-in, Accessories)
      stepIssueTitle: "Detalles Técnicos de tu Consulta",
      stepIssueDesc: "Describe la situación para que nuestros ingenieros y técnicos puedan ayudarte con precisión.",
      vehicleLabel: "Modelo de Vehículo / Motor / Número de Serie (Opcional)",
      vehiclePlaceholder: "Ej. 2004 Honda Civic Si K20 / Serial AX-ECU-902",
      issueLabel: "Descripción del Problema o Duda Técnica",
      issuePlaceholder: "Describe detalladamente lo que ocurre, síntomas, pruebas realizadas...",
      btnSubmitSupport: "Crear Ticket de Soporte",

      // Tuning branch
      stepTuningTitle: "Servicios de Calibración AlphaX",
      stepTuningDesc: "Selecciona la modalidad de afinación o tuning que requieres:",
      cardBaseMapTitle: "Reservar Sesión de Base Map",
      cardBaseMapDesc: "Sesión remota en tiempo real con un técnico para cargar tu mapa base y verificar sensores.",
      cardBaseMapBtn: "Ver / Reservar Sesión de Base Map",
      cardFullTuneTitle: "Referido para Calibración Completa",
      cardFullTuneDesc: "Recomendación y conexión con un calibrador profesional certificado para ajuste en dyno/pista.",
      tuningSetupLabel: "Detalles del Motor y Modificaciones:",
      tuningSetupPlaceholder: "Ej. Motor 2JZ-GTE, Turbo Garrett G35, Inyectores 1000cc, Combustible E85...",
      btnSubmitTuning: "Solicitar Asistencia de Tuning",

      // Confirmation Card
      successTitle: "¡Ticket Recibido Exitosamente!",
      successDesc: "Tu solicitud ha sido registrada en el sistema de soporte técnico AlphaX. Un especialista revisará los datos a la brevedad.",
      ticketLabel: "Número de Ticket Generado:",
      btnCopyTicket: "Copiar Ticket ID",
      jotDownTitle: "¡IMPORTANTE! Guarda o anota este número de ticket",
      jotDownDesc: "Lo necesitarás para consultar el estado de tu caso en el portal o comunicarte con nuestros ingenieros.",
      summaryClient: "Cliente:",
      summaryContact: "Contacto:",
      summaryCategory: "Categoría:",
      summaryStatus: "Estado Inicial:",
      summaryStatusVal: "Pendiente de Asignación",
      btnNewInquiry: "Enviar Otra Consulta",

      // Status Lookup Feature
      lookupTrigger: "¿Ya tienes un ticket? Consulta su estado aquí",
      lookupModalTitle: "Consultar Estado de Ticket",
      lookupModalDesc: "Ingresa tu número de ticket para conocer en qué fase se encuentra tu consulta.",
      lookupBtnSearch: "Buscar",
      resCategoryLabel: "Categoría:",
      resUpdatedLabel: "Última Actualización:",
      statusPendingLabel: "1. Pendiente de Asignación",
      statusPendingDesc: "Tu solicitud ha sido recibida exitosamente y se encuentra en fila para ser evaluada y asignada a un técnico especialista.",
      statusProgressLabel: "2. En Progreso / En Diagnóstico",
      statusProgressDesc: "Un técnico o ingeniero está trabajando activamente en la revisión técnica, calibración o diagnóstico de tu consulta.",
      statusFollowupLabel: "3. En Seguimiento",
      statusFollowupDesc: "Tu caso se encuentra en fase de validación o seguimiento final para confirmar el correcto funcionamiento de tu vehículo o producto.",
      statusClosedLabel: "Resuelto / Archivado",
      statusClosedDesc: "Este ticket ha sido completado satisfactoriamente y archivado en nuestro registro histórico.",

      // Active Ticket Warning Modal
      activeModalTitle: "Ticket Activo Detectado",
      activeModalNotice: "Hemos detectado que tu correo electrónico ya tiene un caso de soporte activo en nuestro sistema:",
      activeTicketIdLabel: "Ticket ID:",
      activeCategoryLabel: "Categoría:",
      activeDateLabel: "Fecha de Creación:",
      activeConsequenceTitle: "⚠️ Importante: ¿Qué sucede si creas un nuevo ticket?",
      activeConsequence1: "Tu ticket anterior <strong>será archivado automáticamente</strong> y reemplazado.",
      activeConsequence2: "Tu nuevo caso se colocará <strong>al final de la fila de prioridad</strong> (perderás tu turno de espera actual).",
      btnCheckExisting: "Consultar mi Ticket Actual (Recomendado)",
      btnProceedReplace: "Entendido, Reemplazar y Continuar",
      replacedTicketNoticeText: "Tu ticket anterior {id} fue archivado automáticamente y reemplazado por esta nueva solicitud.",
      checkingEmailNotice: "Verificando tickets previos..."
    },
    en: {
      brandBadge: "AlphaX Support & Assistance",
      mainTitle: "AlphaX Support & Help Center",
      mainDesc: "Follow the steps below to direct your inquiry to the right technician or specialist.",
      langLabel: "Language:",
      
      step1Title: "Step 1: Contact Information",
      step1Desc: "Provide your details so we can reach you and send ticket updates.",
      nameLabel: "Full Name",
      namePlaceholder: "e.g. Carlos Santana",
      emailLabel: "Email Address",
      emailPlaceholder: "carlos@example.com",
      phoneLabel: "Phone / WhatsApp",
      phonePlaceholder: "e.g. 787-555-0123",
      btnNext: "Continue",
      btnBack: "Back",
      
      step2Title: "How can we help you today?",
      step2Desc: "Select the primary department for your request:",
      cardSalesTitle: "Sales & Product Guidance",
      cardSalesDesc: "Pricing, compatibility, authorized dealers or direct online purchases.",
      cardSupportTitle: "Technical Support",
      cardSupportDesc: "ECU installation help, accessories, diagnostic troubleshooting or tuning.",

      stepSalesTitle: "Sales Orientation & Where to Buy",
      stepSalesDesc: "Choose the option that matches your sales inquiry:",
      cardOrientationTitle: "Product Orientation",
      cardOrientationDesc: "Questions regarding which ECU or accessories fit your vehicle build.",
      cardDealersTitle: "Availability & Where to Buy",
      cardDealersDesc: "Find authorized dealers near you or shop online directly.",
      dealersLinkTitle: "View Authorized Dealer List",
      dealersLinkDesc: "Locate dealer shops in Puerto Rico, USA, and worldwide.",
      storeLinkTitle: "Visit Official AlphaX Store",
      storeLinkDesc: "Direct online purchases of genuine AlphaX ECUs, harnesses and parts.",
      salesNotesLabel: "Tell us about your build or question:",
      salesNotesPlaceholder: "Specify vehicle, engine, and goals so we can guide you...",
      btnSubmitSales: "Submit Sales Inquiry",

      stepSupportTitle: "Select your Product or Service",
      stepSupportDesc: "Choose the category relevant to your technical request:",
      cardPnpTitle: "Plug and Play ECU",
      cardPnpDesc: "Direct-fit standalone ECUs designed for factory harness compatibility.",
      cardWireInTitle: "Wire-in / Universal ECU",
      cardWireInDesc: "Standalone universal ECUs for custom engine swaps and bespoke wiring.",
      cardAccessoriesTitle: "AlphaX Accessories",
      cardAccessoriesDesc: "Pressure sensors, boost solenoids, auxiliary harnesses and expander modules.",
      cardTuningTitle: "Tuning & Calibration Support",
      cardTuningDesc: "Initial startup base maps, remote calibration sessions, and pro tuner referrals.",

      stepIssueTitle: "Technical Issue Details",
      stepIssueDesc: "Describe your setup and issue in detail so our technical team can assist promptly.",
      vehicleLabel: "Vehicle Model / Engine Spec / Serial # (Optional)",
      vehiclePlaceholder: "e.g. 2004 Honda Civic Si K20 / Serial AX-ECU-902",
      issueLabel: "Detailed Issue Description",
      issuePlaceholder: "Explain the symptoms, diagnostic tests done, fault codes, etc...",
      btnSubmitSupport: "Submit Support Ticket",

      stepTuningTitle: "AlphaX Calibration Services",
      stepTuningDesc: "Select the calibration assistance format you require:",
      cardBaseMapTitle: "Book Base Map Session",
      cardBaseMapDesc: "Remote real-time session with a certified technician to initialize your ECU map.",
      cardBaseMapBtn: "View / Book Base Map Session",
      cardFullTuneTitle: "Full Tune Pro Referral",
      cardFullTuneDesc: "Referral and connection with a certified calibration specialist for full dyno/track tuning.",
      tuningSetupLabel: "Engine Specs & Modifications:",
      tuningSetupPlaceholder: "e.g. 2JZ-GTE engine, Garrett G35 turbo, 1000cc injectors, E85 fuel...",
      btnSubmitTuning: "Request Tuning Assistance",

      successTitle: "Ticket Received Successfully!",
      successDesc: "Your request has been logged into the AlphaX Technical Support System. A technician will review your case shortly.",
      ticketLabel: "Generated Ticket Number:",
      btnCopyTicket: "Copy Ticket ID",
      jotDownTitle: "IMPORTANT: Save or note down your Ticket ID",
      jotDownDesc: "You will need this Ticket ID to check the status of your case or speak with our engineers.",
      summaryClient: "Client:",
      summaryContact: "Contact:",
      summaryCategory: "Category:",
      summaryStatus: "Initial Status:",
      summaryStatusVal: "Pending Assignment",
      btnNewInquiry: "Submit Another Inquiry",

      // Status Lookup Feature
      lookupTrigger: "Already have a ticket? Check status here",
      lookupModalTitle: "Check Ticket Status",
      lookupModalDesc: "Enter your ticket number to see the current progress of your case.",
      lookupBtnSearch: "Search",
      resCategoryLabel: "Category:",
      resUpdatedLabel: "Last Updated:",
      statusPendingLabel: "1. Pending Assignment",
      statusPendingDesc: "Your inquiry has been logged and is queued for assignment to a technical specialist.",
      statusProgressLabel: "2. In Progress / In Diagnosis",
      statusProgressDesc: "A technician or calibration engineer is actively investigating and troubleshooting your case.",
      statusFollowupLabel: "3. Follow Up",
      statusFollowupDesc: "Your case is undergoing final validation or follow-up to confirm complete resolution.",
      statusClosedLabel: "Resolved / Archived",
      statusClosedDesc: "This ticket has been resolved and stored in our completed archives.",

      // Active Ticket Warning Modal
      activeModalTitle: "Active Ticket Detected",
      activeModalNotice: "We detected that your email address already has an active support ticket in our system:",
      activeTicketIdLabel: "Ticket ID:",
      activeCategoryLabel: "Category:",
      activeDateLabel: "Date Created:",
      activeConsequenceTitle: "⚠️ Important: What happens if you create a new ticket?",
      activeConsequence1: "Your previous ticket <strong>will be automatically archived</strong> and replaced.",
      activeConsequence2: "Your new case will be placed <strong>at the bottom of the priority queue</strong> (you will lose your current place in line).",
      btnCheckExisting: "View My Existing Ticket (Recommended)",
      btnProceedReplace: "I Understand, Replace & Proceed",
      replacedTicketNoticeText: "Your previous ticket {id} was automatically archived and replaced by this new request.",
      checkingEmailNotice: "Checking existing tickets..."
    }
  };

  // State
  const state = {
    lang: 'es', // Default to Spanish as requested
    currentStep: 'step-1',
    history: ['step-1'],
    formData: {
      name: '',
      email: '',
      phone: '',
      inquiryType: '', // 'sales' or 'support'
      subCategory: '', // 'Product Orientation', 'Plug and Play ECU', 'Wire-in ECU', 'AlphaX Accessories', 'Tuning - Base Map Session', 'Tuning - Full Tune Referral'
      clientNotes: '',
      vehicle: ''
    },
    createdTicketId: null,
    activeTicketWarningAcknowledged: false,
    supersededTicketId: null,
    pendingSupersededTicket: null,
    lastCheckedEmail: null
  };

  // DOM Elements cache
  let dom = {};

  function init() {
    cacheDom();
    bindEvents();
    renderLanguage();
    showStep('step-1');
  }

  function cacheDom() {
    dom.container = document.getElementById('ax-support-wizard-app');
    dom.langEsBtn = document.getElementById('ax-btn-lang-es');
    dom.langEnBtn = document.getElementById('ax-btn-lang-en');
    
    // Steps
    dom.step1 = document.getElementById('ax-step-1');
    dom.step2 = document.getElementById('ax-step-2');
    dom.stepSales = document.getElementById('ax-step-sales');
    dom.stepSupport = document.getElementById('ax-step-support');
    dom.stepIssue = document.getElementById('ax-step-issue');
    dom.stepTuning = document.getElementById('ax-step-tuning');
    dom.stepSuccess = document.getElementById('ax-step-success');

    // Inputs
    dom.inputName = document.getElementById('ax-input-name');
    dom.inputEmail = document.getElementById('ax-input-email');
    dom.inputPhone = document.getElementById('ax-input-phone');
    dom.inputVehicle = document.getElementById('ax-input-vehicle');
    dom.inputIssueNotes = document.getElementById('ax-input-issue-notes');
    dom.inputSalesNotes = document.getElementById('ax-input-sales-notes');
    dom.inputTuningNotes = document.getElementById('ax-input-tuning-notes');

    // Cards
    dom.cardSales = document.getElementById('ax-card-opt-sales');
    dom.cardSupport = document.getElementById('ax-card-opt-support');

    dom.cardSalesOrient = document.getElementById('ax-card-sales-orient');
    dom.cardSalesDealers = document.getElementById('ax-card-sales-dealers');

    dom.cardPnp = document.getElementById('ax-card-sup-pnp');
    dom.cardWireIn = document.getElementById('ax-card-sup-wirein');
    dom.cardAcc = document.getElementById('ax-card-sup-acc');
    dom.cardTuning = document.getElementById('ax-card-sup-tuning');

    dom.cardTuneBasemap = document.getElementById('ax-card-tune-basemap');
    dom.cardTuneFull = document.getElementById('ax-card-tune-full');

    // Buttons
    dom.btnStep1Next = document.getElementById('ax-btn-step1-next');
    dom.btnSalesSubmit = document.getElementById('ax-btn-sales-submit');
    dom.btnIssueSubmit = document.getElementById('ax-btn-issue-submit');
    dom.btnTuningSubmit = document.getElementById('ax-btn-tuning-submit');
    dom.btnNewInquiry = document.getElementById('ax-btn-new-inquiry');

    // Summary outputs
    dom.successTicketId = document.getElementById('ax-success-ticket-id');
    dom.sumClient = document.getElementById('ax-sum-client');
    dom.sumContact = document.getElementById('ax-sum-contact');
    dom.sumCategory = document.getElementById('ax-sum-category');
    dom.replacedTicketNotice = document.getElementById('ax-replaced-ticket-notice');
    dom.replacedTicketText = document.getElementById('ax-replaced-ticket-text');

    // Active Ticket Warning Modal Elements
    dom.activeTicketModal = document.getElementById('ax-active-ticket-modal');
    dom.btnCloseActiveWarn = document.getElementById('ax-btn-close-active-warn');
    dom.btnCheckExisting = document.getElementById('ax-btn-check-existing');
    dom.btnProceedReplace = document.getElementById('ax-btn-proceed-replace');
    dom.warnTicketId = document.getElementById('ax-warn-ticket-id');
    dom.warnBadgeWrap = document.getElementById('ax-warn-badge-wrap');
    dom.warnCategory = document.getElementById('ax-warn-category');
    dom.warnDate = document.getElementById('ax-warn-date');

    // Status Lookup Elements
    dom.btnOpenLookup = document.getElementById('ax-btn-open-lookup');
    dom.lookupModal = document.getElementById('ax-status-lookup-modal');
    dom.btnCloseLookup = document.getElementById('ax-btn-close-lookup');
    dom.formLookup = document.getElementById('ax-form-lookup');
    dom.inputLookupId = document.getElementById('ax-input-lookup-id');
    dom.lookupError = document.getElementById('ax-lookup-error');
    dom.lookupResultBox = document.getElementById('ax-lookup-result-box');
    dom.resTicketId = document.getElementById('ax-res-ticket-id');
    dom.resDate = document.getElementById('ax-res-date');
    dom.resBadgeWrap = document.getElementById('ax-res-badge-wrap');
    dom.resStatusDesc = document.getElementById('ax-res-status-desc');
    dom.resCategory = document.getElementById('ax-res-category');
    dom.resUpdated = document.getElementById('ax-res-updated');
  }

  function bindEvents() {
    // Language switch
    if (dom.langEsBtn) dom.langEsBtn.addEventListener('click', () => setLanguage('es'));
    if (dom.langEnBtn) dom.langEnBtn.addEventListener('click', () => setLanguage('en'));

    // Step 1: Contact
    if (dom.btnStep1Next) {
      dom.btnStep1Next.addEventListener('click', async (e) => {
        e.preventDefault();
        const name = dom.inputName.value.trim();
        const email = dom.inputEmail.value.trim();
        const phone = dom.inputPhone.value.trim();

        if (!name) {
          showToast(state.lang === 'es' ? 'Por favor ingresa tu nombre completo.' : 'Please enter your full name.');
          dom.inputName.focus();
          return;
        }
        if (!email || !email.includes('@')) {
          showToast(state.lang === 'es' ? 'Por favor ingresa un correo electrónico válido.' : 'Please enter a valid email address.');
          dom.inputEmail.focus();
          return;
        }

        state.formData.name = name;
        state.formData.email = email;
        state.formData.phone = phone;
        state.formData.language = state.lang;

        // If user already acknowledged replacing an active ticket for this exact email, proceed
        if (state.activeTicketWarningAcknowledged && state.lastCheckedEmail === email.toLowerCase()) {
          showStep('step-2');
          return;
        }

        // Check if there is an active support ticket registered under this email
        const originalBtnHtml = dom.btnStep1Next.innerHTML;
        dom.btnStep1Next.disabled = true;
        const checkingText = I18N[state.lang]?.checkingEmailNotice || (state.lang === 'es' ? 'Verificando tickets previos...' : 'Checking existing tickets...');
        dom.btnStep1Next.innerHTML = `<span>${checkingText}</span>`;

        try {
          const activeTicket = await findActiveTicketByEmail(email);
          if (activeTicket) {
            state.pendingSupersededTicket = activeTicket;
            state.lastCheckedEmail = email.toLowerCase();
            showActiveTicketWarningModal(activeTicket);
            return;
          }
        } catch (err) {
          console.warn("Active ticket pre-check error:", err);
        } finally {
          dom.btnStep1Next.disabled = false;
          dom.btnStep1Next.innerHTML = originalBtnHtml;
        }

        showStep('step-2');
      });
    }

    // Active Ticket Warning Modal Events
    if (dom.btnCloseActiveWarn) {
      dom.btnCloseActiveWarn.addEventListener('click', () => {
        if (dom.activeTicketModal) dom.activeTicketModal.classList.remove('active');
      });
    }

    if (dom.btnCheckExisting) {
      dom.btnCheckExisting.addEventListener('click', () => {
        if (dom.activeTicketModal) dom.activeTicketModal.classList.remove('active');
        if (state.pendingSupersededTicket) {
          if (dom.lookupModal) dom.lookupModal.classList.add('active');
          if (dom.inputLookupId) {
            dom.inputLookupId.value = state.pendingSupersededTicket.id;
          }
          queryTicketStatus(state.pendingSupersededTicket.id);
        }
      });
    }

    if (dom.btnProceedReplace) {
      dom.btnProceedReplace.addEventListener('click', () => {
        state.activeTicketWarningAcknowledged = true;
        if (state.pendingSupersededTicket) {
          state.supersededTicketId = state.pendingSupersededTicket.id;
        }
        if (dom.activeTicketModal) dom.activeTicketModal.classList.remove('active');
        showStep('step-2');
      });
    }

    // Step 2: Sales vs Support
    if (dom.cardSales) {
      dom.cardSales.addEventListener('click', () => {
        state.formData.inquiryType = 'sales';
        showStep('step-sales');
      });
    }
    if (dom.cardSupport) {
      dom.cardSupport.addEventListener('click', () => {
        state.formData.inquiryType = 'support';
        showStep('step-support');
      });
    }

    // Step Sales Choices
    if (dom.cardSalesOrient) {
      dom.cardSalesOrient.addEventListener('click', () => {
        state.formData.subCategory = 'Product Orientation';
        document.querySelectorAll('#ax-step-sales .ax-option-card').forEach(c => c.classList.remove('selected'));
        dom.cardSalesOrient.classList.add('selected');
        document.getElementById('ax-sales-notes-box').style.display = 'block';
      });
    }
    if (dom.cardSalesDealers) {
      dom.cardSalesDealers.addEventListener('click', () => {
        state.formData.subCategory = 'Availability & Where to Buy';
        document.querySelectorAll('#ax-step-sales .ax-option-card').forEach(c => c.classList.remove('selected'));
        dom.cardSalesDealers.classList.add('selected');
        document.getElementById('ax-sales-notes-box').style.display = 'block';
      });
    }
    if (dom.btnSalesSubmit) {
      dom.btnSalesSubmit.addEventListener('click', (e) => {
        e.preventDefault();
        state.formData.clientNotes = dom.inputSalesNotes.value.trim() || 'Inquiry regarding ' + (state.formData.subCategory || 'AlphaX products');
        submitTicket();
      });
    }

    // Step Support: 4 Options
    if (dom.cardPnp) {
      dom.cardPnp.addEventListener('click', () => {
        state.formData.subCategory = 'Plug and Play ECU';
        showStep('step-issue');
      });
    }
    if (dom.cardWireIn) {
      dom.cardWireIn.addEventListener('click', () => {
        state.formData.subCategory = 'Wire-in ECU';
        showStep('step-issue');
      });
    }
    if (dom.cardAcc) {
      dom.cardAcc.addEventListener('click', () => {
        state.formData.subCategory = 'AlphaX Accessories';
        showStep('step-issue');
      });
    }
    if (dom.cardTuning) {
      dom.cardTuning.addEventListener('click', () => {
        state.formData.subCategory = 'Tuning Support';
        showStep('step-tuning');
      });
    }

    // Step Issue Submit
    if (dom.btnIssueSubmit) {
      dom.btnIssueSubmit.addEventListener('click', (e) => {
        e.preventDefault();
        const vehicle = dom.inputVehicle.value.trim();
        const notes = dom.inputIssueNotes.value.trim();

        if (!notes) {
          showToast(state.lang === 'es' ? 'Por favor describe tu consulta o problema.' : 'Please describe your inquiry or issue.');
          dom.inputIssueNotes.focus();
          return;
        }

        state.formData.vehicle = vehicle;
        state.formData.clientNotes = (vehicle ? `[Vehicle/Spec: ${vehicle}]\n\n` : '') + notes;
        submitTicket();
      });
    }

    // Step Tuning Choices
    if (dom.cardTuneBasemap) {
      dom.cardTuneBasemap.addEventListener('click', () => {
        state.formData.subCategory = 'Tuning - Base Map Session';
        document.querySelectorAll('#ax-step-tuning .ax-option-card').forEach(c => c.classList.remove('selected'));
        dom.cardTuneBasemap.classList.add('selected');
        document.getElementById('ax-tuning-notes-box').style.display = 'block';
      });
    }
    if (dom.cardTuneFull) {
      dom.cardTuneFull.addEventListener('click', () => {
        state.formData.subCategory = 'Tuning - Full Tune Referral';
        document.querySelectorAll('#ax-step-tuning .ax-option-card').forEach(c => c.classList.remove('selected'));
        dom.cardTuneFull.classList.add('selected');
        document.getElementById('ax-tuning-notes-box').style.display = 'block';
      });
    }
    if (dom.btnTuningSubmit) {
      dom.btnTuningSubmit.addEventListener('click', (e) => {
        e.preventDefault();
        const setup = dom.inputTuningNotes.value.trim();
        state.formData.clientNotes = setup || 'Request for ' + (state.formData.subCategory || 'Tuning Assistance');
        submitTicket();
      });
    }

    // Back buttons
    document.querySelectorAll('.ax-btn-back').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        goBack();
      });
    });

    // Status Lookup Modal events
    if (dom.btnOpenLookup) {
      dom.btnOpenLookup.addEventListener('click', () => {
        if (dom.lookupModal) dom.lookupModal.classList.add('active');
        if (dom.lookupError) dom.lookupError.style.display = 'none';
        if (dom.lookupResultBox) dom.lookupResultBox.style.display = 'none';
        if (dom.inputLookupId) {
          dom.inputLookupId.value = '';
          dom.inputLookupId.focus();
        }
      });
    }

    if (dom.btnCloseLookup) {
      dom.btnCloseLookup.addEventListener('click', () => {
        if (dom.lookupModal) dom.lookupModal.classList.remove('active');
      });
    }

    if (dom.formLookup) {
      dom.formLookup.addEventListener('submit', async (e) => {
        e.preventDefault();
        const ticketId = dom.inputLookupId.value.trim().toUpperCase();
        if (!ticketId) return;
        await queryTicketStatus(ticketId);
      });
    }

    // Copy Ticket ID button
    const copyBtn = document.getElementById('ax-btn-copy-ticket');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        if (state.createdTicketId) {
          navigator.clipboard.writeText(state.createdTicketId).then(() => {
            const textSpan = document.getElementById('ax-copy-ticket-text');
            if (textSpan) {
              textSpan.textContent = state.lang === 'es' ? '✓ ¡Ticket ID Copiado!' : '✓ Ticket ID Copied!';
              setTimeout(() => {
                textSpan.textContent = state.lang === 'es' ? 'Copiar Ticket ID' : 'Copy Ticket ID';
              }, 2500);
            }
            showToast(state.lang === 'es' ? '¡Ticket ID copiado al portapapeles!' : 'Ticket ID copied to clipboard!');
          }).catch(() => {
            showToast(state.lang === 'es' ? `Número de Ticket: ${state.createdTicketId}` : `Ticket Number: ${state.createdTicketId}`);
          });
        }
      });
    }

    // New inquiry
    if (dom.btnNewInquiry) {
      dom.btnNewInquiry.addEventListener('click', (e) => {
        e.preventDefault();
        resetWizard();
      });
    }
  }

  // Find if user already has an active support ticket by email
  async function findActiveTicketByEmail(email) {
    if (!email) return null;
    const cleanEmail = email.trim().toLowerCase();

    // 1. Check LocalStorage active tickets
    try {
      const localActive = JSON.parse(localStorage.getItem('alphax_support_tickets') || '[]');
      if (Array.isArray(localActive)) {
        const match = localActive.find(t => {
          if (!t) return false;
          const tEmail = (t.client && t.client.email) ? t.client.email.trim().toLowerCase() : (t.email ? t.email.trim().toLowerCase() : '');
          const st = (t.status || 'pending').toLowerCase();
          const isActive = st === 'pending' || st === 'in_progress' || st === 'follow_up' || st.includes('pending') || st.includes('progress') || st.includes('follow');
          return tEmail === cleanEmail && isActive;
        });

        if (match) {
          return {
            id: String(match.id),
            status: match.status || 'pending',
            subCategory: match.subCategory || 'Soporte General',
            inquiryType: match.inquiryType || 'support',
            createdAt: match.createdAt || new Date().toISOString()
          };
        }
      }
    } catch (e) {
      console.warn("Local active ticket check error:", e);
    }

    // 2. Query Google Apps Script backend if configured
    if (APPS_SCRIPT_URL && !APPS_SCRIPT_URL.includes('YOUR_DEPLOYED_APPS_SCRIPT')) {
      try {
        const resp = await fetch(APPS_SCRIPT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({ action: 'checkActiveTicketByEmail', email: cleanEmail })
        });
        const res = await resp.json();
        if (res && res.success && res.hasActive && res.ticket) {
          return res.ticket;
        }
      } catch (err) {
        console.warn("GAS checkActiveTicketByEmail notice:", err);
      }
    }

    return null;
  }

  function showActiveTicketWarningModal(ticket) {
    const t = I18N[state.lang] || I18N.es;
    if (dom.warnTicketId) dom.warnTicketId.textContent = ticket.id;
    if (dom.warnCategory) dom.warnCategory.textContent = ticket.subCategory || ticket.inquiryType || 'Soporte';
    if (dom.warnDate) dom.warnDate.textContent = ticket.createdAt ? new Date(ticket.createdAt).toLocaleDateString() : '-';

    if (dom.warnBadgeWrap) {
      let st = (ticket.status || 'pending').toLowerCase();
      let badgeClass = 'pending';
      let badgeText = t.statusPendingLabel;
      if (st.includes('progress') || st === 'in_progress') {
        badgeClass = 'in_progress';
        badgeText = t.statusProgressLabel;
      } else if (st.includes('follow') || st === 'follow_up') {
        badgeClass = 'follow_up';
        badgeText = t.statusFollowupLabel;
      }
      dom.warnBadgeWrap.innerHTML = `<span class="ax-status-pill ${badgeClass}">${badgeText}</span>`;
    }

    if (dom.activeTicketModal) {
      dom.activeTicketModal.classList.add('active');
    }
  }

  // Public Ticket Status Query (NO comments, only public state)
  async function queryTicketStatus(ticketId) {
    if (dom.lookupError) dom.lookupError.style.display = 'none';
    if (dom.lookupResultBox) dom.lookupResultBox.style.display = 'none';

    let foundTicket = null;

    // 1. Check local storage
    try {
      const localActive = JSON.parse(localStorage.getItem('alphax_support_tickets') || '[]');
      const matchActive = localActive.find(t => t && t.id && String(t.id).toUpperCase() === ticketId);
      if (matchActive) {
        foundTicket = {
          id: String(matchActive.id),
          status: matchActive.status || 'pending',
          subCategory: matchActive.subCategory || 'Soporte General',
          createdAt: matchActive.createdAt,
          updatedAt: matchActive.updatedAt
        };
      } else {
        const localArch = JSON.parse(localStorage.getItem('alphax_support_archived') || '[]');
        const matchArch = localArch.find(t => t && t.id && String(t.id).toUpperCase() === ticketId);
        if (matchArch) {
          foundTicket = {
            id: String(matchArch.id),
            status: 'closed',
            subCategory: matchArch.subCategory || 'Soporte General',
            createdAt: matchArch.createdAt,
            updatedAt: matchArch.archivedAt || matchArch.updatedAt
          };
        }
      }
    } catch (e) {
      console.warn("Local lookup notice:", e);
    }

    // 2. Query Google Apps Script if URL configured
    if (APPS_SCRIPT_URL && !APPS_SCRIPT_URL.includes('YOUR_DEPLOYED_APPS_SCRIPT')) {
      try {
        const resp = await fetch(APPS_SCRIPT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({ action: 'lookupTicketStatus', ticketId: ticketId })
        });
        const res = await resp.json();
        if (res && res.success && res.ticket) {
          foundTicket = res.ticket;
        }
      } catch (err) {
        console.warn("GAS lookup error:", err);
      }
    }

    if (foundTicket) {
      renderLookupResult(foundTicket);
    } else {
      if (dom.lookupError) {
        dom.lookupError.textContent = state.lang === 'es'
          ? `No se encontró ningún caso con el ID "${ticketId}". Verifica el número e intenta nuevamente.`
          : `No support case found for ID "${ticketId}". Please check the number and try again.`;
        dom.lookupError.style.display = 'block';
      }
    }
  }

  function renderLookupResult(ticket) {
    const t = I18N[state.lang] || I18N.es;
    if (!dom.lookupResultBox) return;

    dom.resTicketId.textContent = ticket.id;
    dom.resDate.textContent = ticket.createdAt ? new Date(ticket.createdAt).toLocaleDateString() : '';
    dom.resCategory.textContent = ticket.subCategory || '-';
    dom.resUpdated.textContent = ticket.updatedAt ? new Date(ticket.updatedAt).toLocaleString() : '-';

    let statusKey = 'pending';
    let statusLabel = t.statusPendingLabel;
    let statusDesc = t.statusPendingDesc;
    let badgeClass = 'pending';
    let iconSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>`;

    if (ticket.status === 'in_progress') {
      statusKey = 'in_progress';
      statusLabel = t.statusProgressLabel;
      statusDesc = t.statusProgressDesc;
      badgeClass = 'in_progress';
      iconSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4"/></svg>`;
    } else if (ticket.status === 'follow_up') {
      statusKey = 'follow_up';
      statusLabel = t.statusFollowupLabel;
      statusDesc = t.statusFollowupDesc;
      badgeClass = 'follow_up';
      iconSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`;
    } else if (ticket.status === 'closed' || ticket.status === 'archived') {
      statusKey = 'closed';
      statusLabel = t.statusClosedLabel;
      statusDesc = t.statusClosedDesc;
      badgeClass = 'closed';
      iconSvg = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>`;
    }

    dom.resBadgeWrap.innerHTML = `
      <div class="ax-status-badge-lg ${badgeClass}">
        ${iconSvg}
        <span>${statusLabel}</span>
      </div>
    `;

    dom.resStatusDesc.textContent = statusDesc;
    dom.lookupResultBox.style.display = 'block';
  }

  function setLanguage(lang) {
    state.lang = lang;
    state.formData.language = lang;
    
    if (dom.langEsBtn && dom.langEnBtn) {
      dom.langEsBtn.classList.toggle('active', lang === 'es');
      dom.langEnBtn.classList.toggle('active', lang === 'en');
    }

    renderLanguage();
  }

  function renderLanguage() {
    const t = I18N[state.lang] || I18N.es;

    // Apply translations using data-i18n attributes
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.getAttribute('data-i18n');
      if (t[key]) {
        el.textContent = t[key];
      }
    });

    document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
      const key = el.getAttribute('data-i18n-placeholder');
      if (t[key]) {
        el.placeholder = t[key];
      }
    });
  }

  function showStep(stepId) {
    state.currentStep = stepId;
    if (!state.history.includes(stepId)) {
      state.history.push(stepId);
    }

    document.querySelectorAll('.ax-step-content').forEach(el => {
      el.classList.remove('active');
    });

    const target = document.getElementById('ax-' + stepId);
    if (target) {
      target.classList.add('active');
    }

    // Scroll to top of card container
    if (dom.container) {
      dom.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function goBack() {
    if (state.history.length > 1) {
      state.history.pop(); // Remove current
      const prevStep = state.history[state.history.length - 1];
      showStep(prevStep);
    } else {
      showStep('step-1');
    }
  }

  function resetWizard() {
    state.history = ['step-1'];
    state.formData = {
      name: '',
      email: '',
      phone: '',
      inquiryType: '',
      subCategory: '',
      clientNotes: '',
      vehicle: ''
    };
    state.createdTicketId = null;
    state.activeTicketWarningAcknowledged = false;
    state.supersededTicketId = null;
    state.pendingSupersededTicket = null;
    state.lastCheckedEmail = null;

    if (dom.inputName) dom.inputName.value = '';
    if (dom.inputEmail) dom.inputEmail.value = '';
    if (dom.inputPhone) dom.inputPhone.value = '';
    if (dom.inputVehicle) dom.inputVehicle.value = '';
    if (dom.inputIssueNotes) dom.inputIssueNotes.value = '';
    if (dom.inputSalesNotes) dom.inputSalesNotes.value = '';
    if (dom.inputTuningNotes) dom.inputTuningNotes.value = '';

    if (dom.replacedTicketNotice) dom.replacedTicketNotice.style.display = 'none';

    document.querySelectorAll('.ax-option-card').forEach(c => c.classList.remove('selected'));
    const salesNotesBox = document.getElementById('ax-sales-notes-box');
    if (salesNotesBox) salesNotesBox.style.display = 'none';
    const tuningNotesBox = document.getElementById('ax-tuning-notes-box');
    if (tuningNotesBox) tuningNotesBox.style.display = 'none';

    showStep('step-1');
  }

  async function submitTicket() {
    // Generate standard AlphaX support ticket ID
    const ticketId = 'AX-SUP-' + Math.floor(20000 + Math.random() * 80000);
    const now = new Date().toISOString();
    const cleanEmail = (state.formData.email || '').trim().toLowerCase();

    const ticketObj = {
      id: ticketId,
      client: {
        name: state.formData.name,
        email: state.formData.email,
        phone: state.formData.phone,
        language: state.lang
      },
      inquiryType: state.formData.inquiryType,
      subCategory: state.formData.subCategory || 'General Inquiry',
      clientNotes: state.formData.clientNotes,
      status: 'pending', // Starts in Pending column (bottom of FIFO queue)
      assignedStaff: {
        name: 'Unassigned',
        role: 'Staff',
        avatar: 'UN'
      },
      createdAt: now,
      updatedAt: now,
      pendingComments: [],
      inProgressComments: [],
      followUpComments: []
    };

    // Auto-archive active tickets for this email in LocalStorage and prepend new ticket
    try {
      let localTickets = [];
      let localArchived = [];
      const rawTickets = localStorage.getItem('alphax_support_tickets');
      const rawArchived = localStorage.getItem('alphax_support_archived');
      
      if (rawTickets) localTickets = JSON.parse(rawTickets);
      if (rawArchived) localArchived = JSON.parse(rawArchived);
      if (!Array.isArray(localTickets)) localTickets = [];
      if (!Array.isArray(localArchived)) localArchived = [];

      const remainingTickets = [];
      localTickets.forEach(t => {
        if (!t) return;
        const tEmail = (t.client && t.client.email) ? t.client.email.trim().toLowerCase() : (t.email ? t.email.trim().toLowerCase() : '');
        const st = (t.status || '').toLowerCase();
        const isActive = st === 'pending' || st === 'in_progress' || st === 'follow_up' || st.includes('pending') || st.includes('progress') || st.includes('follow');

        if (tEmail === cleanEmail && isActive) {
          // Auto-archive the previous active ticket
          const archivedObj = {
            ...t,
            status: 'archived',
            archivedAt: now,
            archivedBy: 'System (Superseded by ' + ticketId + ')'
          };
          localArchived.unshift(archivedObj);
          if (!state.supersededTicketId) {
            state.supersededTicketId = t.id;
          }
        } else {
          remainingTickets.push(t);
        }
      });

      remainingTickets.unshift(ticketObj);
      localStorage.setItem('alphax_support_tickets', JSON.stringify(remainingTickets));
      localStorage.setItem('alphax_support_archived', JSON.stringify(localArchived));
    } catch (e) {
      console.warn("LocalStorage auto-archive / save note:", e);
    }

    // Try Google Apps Script if URL is provided
    if (APPS_SCRIPT_URL && !APPS_SCRIPT_URL.includes('YOUR_DEPLOYED_APPS_SCRIPT')) {
      try {
        fetch(APPS_SCRIPT_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({
            action: 'createSupportTicket',
            id: ticketId,
            name: state.formData.name,
            email: state.formData.email,
            phone: state.formData.phone,
            language: state.lang,
            inquiryType: state.formData.inquiryType,
            subCategory: state.formData.subCategory,
            clientNotes: state.formData.clientNotes,
            supersededTicketId: state.supersededTicketId || '',
            archiveExistingForEmail: true
          })
        }).catch(err => console.warn("Google Apps Script sync notice:", err));
      } catch (err) {
        console.warn("GAS notice:", err);
      }
    }

    // Update Confirmation Screen
    state.createdTicketId = ticketId;
    if (dom.successTicketId) dom.successTicketId.textContent = ticketId;
    if (dom.sumClient) dom.sumClient.textContent = state.formData.name;
    if (dom.sumContact) dom.sumContact.textContent = `${state.formData.email} ${state.formData.phone ? '• ' + state.formData.phone : ''}`;
    if (dom.sumCategory) dom.sumCategory.textContent = `${state.formData.inquiryType === 'sales' ? 'Ventas / Sales' : 'Soporte'} > ${state.formData.subCategory}`;

    // Display superseded banner if an older ticket was archived
    if (state.supersededTicketId && dom.replacedTicketNotice) {
      dom.replacedTicketNotice.style.display = 'flex';
      if (dom.replacedTicketText) {
        const msgPattern = (I18N[state.lang] || I18N.es).replacedTicketNoticeText || 'Tu ticket anterior {id} fue archivado automáticamente y reemplazado por esta nueva solicitud.';
        dom.replacedTicketText.textContent = msgPattern.replace('{id}', state.supersededTicketId);
      }
    } else if (dom.replacedTicketNotice) {
      dom.replacedTicketNotice.style.display = 'none';
    }

    showStep('step-success');
    showToast(state.lang === 'es' ? `¡Ticket ${ticketId} registrado con éxito!` : `Ticket ${ticketId} created successfully!`);
  }

  function showToast(msg) {
    const toast = document.createElement('div');
    toast.className = 'ax-toast';
    toast.textContent = msg;
    document.body.appendChild(toast);
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.4s ease';
      setTimeout(() => toast.remove(), 400);
    }, 3500);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
